import React from 'react'
import { Avatar, Divider, NavigationDrawer } from 'react-md'
import { truncate } from 'underscore.string'

import { UserStatic } from 'api'
import { NavigationLink } from 'components'
import { UserRole } from 'api/enums'
import * as routes from 'routes'

import logo from './images/logo.png'

import './Layout.css'

const drawerHeader = (user) => (
  <div className='md-toolbar'>
    <Avatar
      key='profile'
      className='profile'
      src={UserStatic.getImageURL(user.id, user.signature)}
      role='presentation'
      alt='profile'
    />
    <div id='profile' className='profile-menu'>
      {
        truncate(user.artisticName || `${user.firstName} ${user.lastName}`, 18)
      }
    </div>
  </div>
)

const navigationItems = (role) => {
  if (role === UserRole.MANAGER) {
    return [
      { label: 'Dashboard', to: routes.dashboard(), icon: 'home', exact: true },
      { label: 'My Account', to: routes.account(), icon: 'account_box' },
      { label: 'Export Art', to: routes.exportArtworks(), icon: 'import_export' },
      { label: 'Export Sales', to: routes.exportSales(), icon: 'attach_money' },
      { label: 'Export Artists', to: routes.exportArtists(), icon: 'contacts' },
      { label: 'Sign out', to: routes.signOut(), icon: 'exit_to_app', divider: true }
    ]
  } else {
    return [
      { label: 'Home', to: routes.artistHome(), icon: 'home', exact: true },
      { label: 'My Account', to: routes.account(), icon: 'account_box' },
      { label: 'My Art', to: routes.artworks(), icon: 'image' },
      { label: 'My Sales', to: routes.sales(), icon: 'attach_money' },
      { label: 'Upload Art', to: routes.upload(), icon: 'file_upload' },
      { label: 'Sign out', to: routes.signOut(), icon: 'exit_to_app', divider: true }
    ]
  }
}

const Layout = ({ user, children }) => (
  <NavigationDrawer
    toolbarTitle='&nbsp;'
    toolbarChildren={<img src={logo} className='logo' alt='logo' />}
    drawerHeaderChildren={drawerHeader(user)}
    mobileDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
    tabletDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
    desktopDrawerType={NavigationDrawer.DrawerTypes.FIXED}
    toolbarThemeType='themed'
    navItems={navigationItems(user.role).map(props =>
      props.divider ? (
        <div key={props.to}>
          <Divider />
          <NavigationLink {...props} />
        </div>
      ) : (
        <NavigationLink {...props} key={props.to} />
      )
    )}
  >
    { children }
  </NavigationDrawer>
)

export default Layout



// WEBPACK FOOTER //
// ./src/containers/PrivateRoot/Layout.js